module.exports = __webpack_public_path__ + "img/my-garden.3d3abd62.jpg";